<template>
    <Loading v-if="is_updating" />
    <Sidebar v-if="$store.state.user_data"/>
    <Content class="application-item-content">
        <Loading class="static static-back" v-if="is_loading"/>
        <div class="inner inner-box" v-else>
            <header>
                <div class="top-bar">
                    <router-link to="/programs/applications-list" class="back-btn">
                        <svg-icon name="arrow-next" />
                        <span>Recruitment</span>
                    </router-link>
                    <p>
                        <!-- <router-link :to="'/help'"> Feedback</router-link> -->
                        <a class="edit-btn" target="_blank" :href="`mailto:${$store.state.mail_to}?subject=Feedback&body=Please%20describe%20your%20issue%20below%20in%20as%20much%20detail%20as%20possible%20(including%20what%20device%20you're%20using%20and%20screenshots,%20if%20necessary).%20A%20support%20team%20member%20will%20contact%20you%20within%201-2%20business%20days.`">
                            Feedback 
                        </a>
                        <span class="edit-btn" @click="openEditForm()" v-if="permission_recruitment?.editApplicationSettings?.permission">
                            <svg-icon name="pen"/>
                            Form 
                        </span>
                        <span class="edit-btn icon" @click="openEdit()" v-if="permission_recruitment?.editApplicationSettings?.permission">
                            <svg-icon name="edit" style="margin: 0;" />
                        </span>
                        <Button class="view-btn enabled-btn" :style="'border-square'" color="black-90" size="32" @click="openShare" :is_disabled="$store.state.merchant_disabeld">View & Share</Button>
                    </p>
                </div>

                <div class="app-header">
                    <!-- Unable to send more storefront invites as you've reached your maximum allowance.
                    {{ this.$store.state.current_creator_count + '-' +  this.send_invite_list.length + '-' + this.$store.state.creator_max_count }} -->
                    <h1 v-html="`${info.title}<span>${info.program_tag}</span>`"> </h1>
                    <ul>
                        <li>
                            <span>Created: </span>
                            <time><svg-icon name="calendar2" />{{ moment(info.created_at).format('MMM DD, YYYY') }}</time>
                        </li>
                        <li>
                            <span>Application Period: </span>
                            <time><svg-icon name="calendar2" />{{ setDate() }}</time>
                        </li>
                        <li>
                            <span>Application Status: </span>
                            <label class="accepting" :class="'status-' + info.status">{{ info.status_name }}</label>
                        </li>
                        <li>
                            <transition name="fade">
                                <span v-if="!is_show_msg" @click="toggleMsg('open')"><svg-icon name="idea" /> Tips/Guide</span>
                            </transition>
                        </li>
                    </ul>
                </div>

                <slide-up-down v-model="is_show_msg" :duration="300">
                    <div class="msg">
                        <svg-icon name="alert" />
                        <p>Accepting a creator's application does not guarantee their participation in your campaign. After you make a decision, please contact them via email or DM.</p>
                        <i class="close" @click="toggleMsg('close')"><svg-icon name="close" /></i>
                    </div>
                </slide-up-down>

                <div class="statistic" v-if="!is_loading">
                    <ul v-if="statistic">
                        <li v-for="(item, index) in statistic" :key="index" :class="[{
                            'active': (params.decision.filter((o) => o === item.field_status).length !== 0) || (item.field_status === 9999 && params.decision.length === 0)
                         }, {'disabled': !item.count}]" @click="updateType(item)"><strong>{{ item.count }}</strong><span>{{ item.field_status_text === 'Reviewing' ? 'In Review' : item.field_status_text }}</span></li>
                    </ul>
                </div>
                
                <div class="drop-box">
                    <FilterDropdown 
                    :params="params" 
                    :disabled="is_empty_data && !is_filtered" 
                    :is_app="true" 
                    :review_status="statistic"
                    :storefront_status="storefront_status"
                    :recently_submitted="recently_submitted"
                    :hide_fields="hide_fields"
                    @update-filter="fetchData()" />
                    <Search @onenter="search" :disabled="false"/>
                    <Dropdown :items="select_pagenum" :disabled="is_empty_data" @update-dropdown="updatePagenum" />
                    <Pagenavi :disabled="is_empty_data" :page_current="current_page" :page_total="total_page" @goto-page="gotoPage" />
                    <div :class="['email-btn', canNotEdit && 'not-allowed-btn']">
                        <Button :is_disabled="(send_invite_list.length + send_response_list.length) === 0" :style="'border-square'" color="dark-blue" size="32" @click="is_show_email_menu = !is_show_email_menu">
                            <svg-icon name="email" />
                        </Button>
                        <ul v-show="is_show_email_menu">
                            <li @click="openSendModal('response')" :class="{'disabled': send_response_list.length === 0}">Send Response{{ send_response_list.length > 1 ? 's' : '' }}</li>
                            <!-- <li @click="openSendModal('response_externally')" :class="{'disabled': send_response_list.length === 0}">Send Decision Email Externally</li> -->
                            <li @click="openSendModal('invite')" :class="{'disabled': send_invite_list.length === 0}">Invite to Storefronts</li>
                            <!-- <li @click="openSendModal('invite_externally')" :class="{'disabled': send_invite_list.length === 0}">Send Storefront Invite Externally</li> -->
                         </ul>
                    </div>

                    <Button :is_disabled="edit_list.length === 0 || canNotEdit" class="edit-btn" :style="'bg-square'" color="dark-blue" size="32"  @click.stop="openMenu('all', $event)">Edit <svg-icon name="down" /></Button>
                    <span class="download-btn" @click="downloadPdf"
                        :class="{ 'disabled': !is_loading && data.length === 0 || !permission_recruitment.viewApplicantDetails.permission }">
                        <svg-icon name="download2" />
                    </span>
                </div>

                <div class="filter-results" v-if="is_filtered">
                    <span class="item" @click="clearFilter('decision')" v-if="params.decision.length !== 0">
                        <span>Review Status: 
                            <template v-for="(item, index) in params.decision">
                                <span v-if="index !== 0">, </span>
                                {{ active_menu.find((o) => o.key === item).text }}
                            </template>
                        </span>
                        <svg-icon name="close" />
                    </span>
                    <span class="item" @click="clearFilter('storefront')" v-if="params.storefront_invite !== 9999">
                        <span>Storefront Status: {{ storefront_status.find((o) => o.status === params.storefront_invite).name }}</span>
                        <svg-icon name="close" />
                    </span>
                    <span class="item" @click="clearFilter('response')" v-if="params.submitted !== 0">
                        <span>Recently Submitted: {{ recently_submitted.find((o) => o.status === params.submitted).name }}</span>
                        <svg-icon name="close" />
                    </span>
                    <span class="item" @click="clearFilter('tiktok')" v-if="params.tiktok_followers.range !== 2 && params.tiktok_followers.val">
                        <span>Social Followers(TikTok) {{ params.tiktok_followers.range === 0 ? 'Greater than' : 'Fewer than' }}: {{ params.tiktok_followers.val }}</span>
                        <svg-icon name="close" />
                    </span>
                    <span class="item" @click="clearFilter('tiktok')" v-else-if="params.tiktok_followers.range === 2 && params.tiktok_followers.min && params.tiktok_followers.max">
                        <span>Social Followers(TikTok): {{ params.tiktok_followers.min }} - {{ params.tiktok_followers.max }}</span>
                        <svg-icon name="close" />
                    </span>
                    <span class="item" @click="clearFilter('instagram')" v-if="params.instagram_followers.range !== 2 && params.instagram_followers.val">
                        <span>Social Followers(Instagram) {{ params.instagram_followers.range === 0 ? 'Greater than' : 'Fewer than' }}: {{ params.instagram_followers.val }}</span>
                        <svg-icon name="close" />
                    </span>
                    <span class="item" @click="clearFilter('instagram')" v-else-if="params.instagram_followers.range === 2 && params.instagram_followers.min && params.instagram_followers.max">
                        <span>Social Followers(Instagram): {{ params.instagram_followers.min }} - {{ params.instagram_followers.max }}</span>
                        <svg-icon name="close" />
                    </span>
                </div>
            </header>
            <NoData v-if="!is_loading && !is_loading_data && data.length === 0" :image="require('@/assets/images/server-hardware.png')" text="" :title="is_filtered || keyword ? 'No results found.' : 'No responses yet.'" />
            <Scrollbar v-else class="data-list" :show_bar="true">
                <Table :style="top" :class="{ 'is-loading': is_loading_data }">
                    <template #head>
                        <tr>
                            <th class="fir-child" @click="$store.state.merchant_disabeld? null : selectAll(data)" v-if="!canNotEdit">
                                <Checkbox :checked="(todo_data.length === data.length)" :disabled="$store.state.merchant_disabeld"/>
                            </th>

                            <th><span>Name</span></th>
                            <th>
                                <div class="ico sort"
                                    :class="[{ 'asc': sort_key === 'submitted' && sort_val === 'asc' }, { 'desc': sort_key === 'submitted' && sort_val === 'desc' }]"
                                    @click="sort('submitted')">
                                    <span>Submitted</span>
                                    <i><svg-icon name="sort" /></i>
                                </div>
                            </th>
                            <th>
                                <div class="ico sort"
                                    :class="[{ 'asc': sort_key === 'reviewed' && sort_val === 'asc' }, { 'desc': sort_key === 'reviewed' && sort_val === 'desc' }]"
                                    @click="sort('reviewed')">
                                    <span>Reviewed</span>
                                    <i><svg-icon name="sort" /></i>
                                </div>
                            </th>
                            <th>
                                <div class="ico sort"
                                    :class="[{ 'asc': sort_key === 'submitted' && sort_val === 'asc' }, { 'desc': sort_key === 'submitted' && sort_val === 'desc' }]"
                                    @click="sort('submitted')">
                                        <tippy :delay="[0, 20]" content="Indicates whether an email about the candidate's status has been dispatched, either approving or rejecting them. Once sent, the decision cannot be altered.">
                                            Decision Email
                                        </tippy>
                                    <i><svg-icon name="sort" /></i>
                                </div>
                            </th>
                            <th>
                                <div class="ico sort"
                                    :class="[{ 'asc': sort_key === 'storefront_invite' && sort_val === 'asc' }, { 'desc': sort_key === 'storefront_invite' && sort_val === 'desc' }]"
                                    @click="sort('storefront_invite')">
                                    <tippy :delay="[0, 20]" content="Shows the current status of the storefront invite. Only applicants who have been approved and notified are eligible to receive an invite.">Storefront Invite</tippy>
                                    <i><svg-icon name="sort" /></i>
                                </div>
                            </th>
                            <th v-if="info.is_show_tiktok_field">
                                <div class="ico sort"
                                    :class="[{ 'asc': sort_key === 'tiktok' && sort_val === 'asc' }, { 'desc': sort_key === 'tiktok' && sort_val === 'desc' }]"
                                    @click="sort('tiktok')">
                                    <span>TikTok</span>
                                    <i><svg-icon name="sort" /></i>
                                </div>
                            </th>
                            <th v-if="info.is_show_tiktok_followers_field">
                                <div class="ico sort"
                                    :class="[{ 'asc': sort_key === 'tiktok_followers' && sort_val === 'asc' }, { 'desc': sort_key === 'tiktok_followers' && sort_val === 'desc' }]"
                                    @click="sort('tiktok_followers')">
                                    <span>TikTok Followers</span>
                                    <i><svg-icon name="sort" /></i>
                                </div>
                            </th>
                            <th v-if="info.is_show_instagram_field">
                                <div class="ico sort"
                                    :class="[{ 'asc': sort_key === 'instagram' && sort_val === 'asc' }, { 'desc': sort_key === 'instagram' && sort_val === 'desc' }]"
                                    @click="sort('instagram')">
                                    <span>Instagram</span>
                                    <i><svg-icon name="sort" /></i>
                                </div>
                            </th>
                            <th v-if="info.is_show_instagram_followers_field">
                                <div class="ico sort"
                                    :class="[{ 'asc': sort_key === 'instagram_followers' && sort_val === 'asc' }, { 'desc': sort_key === 'instagram_followers' && sort_val === 'desc' }]"
                                    @click="sort('instagram_followers')">
                                    <span>Instagram Followers</span>
                                    <i><svg-icon name="sort" /></i>
                                </div>
                            </th>
                            <th v-if="$ProjectName !== 'sephora' && info.is_show_age_field">
                                <div class="ico sort"
                                    :class="[{ 'asc': sort_key === 'age' && sort_val === 'asc' }, { 'desc': sort_key === 'age' && sort_val === 'desc' }]"
                                    @click="sort('age')">
                                    <span>Age</span>
                                    <i><svg-icon name="sort" /></i>
                                </div>
                            </th>
                            <th v-if="info.is_show_country_field">
                                <div class="ico sort"
                                    :class="[{ 'asc': sort_key === 'country' && sort_val === 'asc' }, { 'desc': sort_key === 'country' && sort_val === 'desc' }]"
                                    @click="sort('country')">
                                    <span>Country</span>
                                    <i><svg-icon name="sort" /></i>
                                </div>
                            </th>
                            <th>
                                <div class="ico sort"
                                    :class="[{ 'asc': sort_key === 'decision' && sort_val === 'asc' }, { 'desc': sort_key === 'decision' && sort_val === 'desc' }]"
                                    @click="sort('decision')">
                                    <span>Decision</span>
                                    <i><svg-icon name="sort" /></i>
                                </div>
                            </th>
                        </tr>
                    </template>
                    <template #body>
                        <tr v-for="(row, index) in data" :key="index" @click="open(row)" :class="{'checked': row.selected}">
                            <td class="fir-child"  @click.stop="$store.state.merchant_disabeld? null: select(data, index)" v-if="!canNotEdit">
                                <Checkbox :checked="row.selected" :disabled="$store.state.merchant_disabeld || (row.decision_status===100 && row.response_email_send_status===100)"/>
                            </td>
                            <td>
                                <span class="is-new" v-if="row.is_new">New</span>
                                <template v-if="row.first_name && row.last_name">
                                    {{ row.first_name }} {{ row.last_name }}
                                </template>
                                <template v-else-if="row.display_name">
                                    {{ row.display_name }}
                                </template>
                                <span class="n-a" v-else>---</span>

                                <br>
                                <a class="social-icon" target="_blank" :href="'mailto:' + row.email" v-tippy="{ content: row.email, placement: 'top' }" @click.stop>
                                    <svg-icon name="email" />
                                </a>
                                <a class="social-icon" v-if="row.tiktok_handle" target="_blank" :href="'https://www.tiktok.com/' + row.tiktok_handle" v-tippy="{ content: row.tiktok_handle, placement: 'top' }" @click.stop>
                                    <svg-icon name="tiktok-pure" />
                                </a>
                                <a class="social-icon" v-if="row.instagram_handle" target="_blank" :href="'https://www.instagram.com/' + row.instagram_handle" v-tippy="{ content: '@' + row.instagram_handle, placement: 'top' }" @click.stop>
                                    <svg-icon name="instagram" />
                                </a>
                            </td>
                            <td>{{ row.submitted }}</td>
                            <td>
                                <span v-if="row.decision_status !== 0">{{ row.reviewed }}</span>
                                <span class="n-a" v-else>---</span>
                                <tippy class="automated" :delay="[0, 20]" content="This applicant was automatically rejected because they did not meet the age requirement, follower count, or country criteria specified in the response settings." v-if="row.decision_status !== 0 && row.is_auto_reject">
                                    Automated
                                    <svg-icon name="question" />
                                </tippy>
                            </td>
                            <td :data-val="row.response_email_send_status" :class="[$store.state.merchant_disabeld && 'disabeld']">
                                <p v-html="responseStyle(row)"></p>
                                <p v-if="row.response_email_send_status === 0 && (row.decision_status === 100 || row.decision_status === -10)">
                                    <span :class="['js-link', canNotEdit && 'not-allowed-btn']" @click.stop="$store.state.merchant_disabeld|| canNotEdit ?null:resend(row, 'response')">Send decision</span>
                                    <!-- <br>
                                    <span class="js-link" @click.stop="$store.state.merchant_disabeld?null:resend(row, 'response_externally')">Send decision externally</span> -->
                                </p>
                                <p v-else-if="row.response_email_send_status === -10">
                                    <span :class="['js-link', canNotEdit && 'not-allowed-btn']"  @click.stop="$store.state.merchant_disabeld?null:resend(row, 'response')">Resend</span>
                                </p>
                            </td>
                            <td :data-val="row.storefront_invite_email_send_status" >
                                <p v-html="inviteStyle(row)"></p>
                                <p v-if="row.storefront_invite_email_send_status === -10">
                                    <span :class="['js-link', canNotEdit && 'not-allowed-btn']"  @click.stop="resend(row, 'invite')">Resend</span>
                                </p>
                                <p v-else-if="row.storefront_invite_email_send_status === 20 && row.is_duplicate_anchor_creator_id === null">
                                    <span :class="['js-link', canNotEdit && 'not-allowed-btn']" @click.stop="resend(row, 'invite')">Send invite</span>
                                    <!-- <br>
                                    <span class="js-link" @click.stop="resend(row, 'invite_externally')">Send invite externally</span> -->
                                </p>
                            </td>
                            <td v-if="info.is_show_tiktok_field">
                                <template v-if="row.tiktok_handle">
                                    <a target="_blank" :href="'https://www.tiktok.com/' + row.tiktok_handle" @click.stop>
                                        {{ row.tiktok_handle }}
                                    </a>
                                </template>
                                <span class="n-a" v-else>---</span>
                            </td>
                            <td v-if="info.is_show_tiktok_followers_field">
                                <template v-if="row.tikTok_followers">
                                    {{ row.tikTok_followers }}
                                </template>
                                <span class="n-a" v-else>---</span>
                            </td>
                            <td v-if="info.is_show_instagram_field">
                                <template v-if="row.instagram_handle">
                                    <a target="_blank" :href="'https://www.instagram.com/' + row.instagram_handle" @click.stop>
                                        @{{ row.instagram_handle }}
                                    </a>
                                </template>
                                <span class="n-a" v-else>---</span>
                            </td>
                            <td v-if="info.is_show_instagram_followers_field">
                                <template v-if="row.instagram_followers">
                                    {{ row.instagram_followers }}
                                </template>
                                <span class="n-a" v-else>---</span>
                            </td>
                            <td v-if="$ProjectName !== 'sephora' && info.is_show_age_field">
                                <template v-if="row.age">
                                    {{ row.age }}
                                </template>
                                <span class="n-a" v-else>---</span>
                            </td>
                            <td v-if="info.is_show_country_field">
                                <template v-if="row.country">
                                    {{ row.country }}
                                </template>
                                <span class="n-a" v-else>---</span>
                            </td>
                            <td @click.stop=" $store.state.merchant_disabeld || canNotEdit ? null:openMenu(row, $event)">
                                <span class="status-btn" 
                                    :key="row.decision_status_text" 
                                    :class="['status-' + row.decision_status_class ,$store.state.merchant_disabeld && 'disabeld-btn', (canNotEdit) && 'not-allowed-btn']">
                                    {{ row.decision_status_text }} 
                                    <svg-icon v-if="!$store.state.merchant_disabeld" name="down" />
                                </span>
                            </td>
                        </tr>
                    </template>
                </Table>
            </Scrollbar>
        </div>
    </Content>
    <div class="active-menu" ref="menu">
        <ul>
            <li v-for="(menu, index) in active_menu" :key="index" @click="updateDecisionStatus(menu)" :class="[{'current': menu.current}, {'disabled': menu.is_disabled},{ 'red-menu': menu.key===-10}]">
                <span v-html="menu.current ? menu.text : menu.name"></span><svg-icon v-if="menu.current" name="yes-2" />
            </li>
        </ul>
    </div>
    <Share ref="share" :share_url="info.url" />
    <Modal :is_show="is_show_send_modal" @click-bg="is_show_send_modal = false" class="send-email-modal">
        <header>
            <h2>{{ send_email_type === 'response' ? 'Send: Application Response' : 'Send: Storefront - Invite' }} <span>&nbsp;(No reply)</span></h2>
            <!-- <i @click="is_show_send_modal = false"><svg-icon name="close" /></i> -->
        </header>
        <div class="col" v-if="send_email_type === 'response'">
            <p class="small-text">We will send emails to those who have not previously been sent. </p>
            <p class="msg" v-if="(!info.auto_send_decision_approved || !info.auto_send_decision_reject)">You can set up a schedule and/or automate your emails in the <span :class="[ !permission_recruitment?.editEmailTemplates?.permission && 'not-allowed-btn']" @click="openEdit('email_settings')">email settings</span>.</p>
            <dl v-if="send_response_approved_list.length !== 0">
                <dt>
                    <h3>To all selected approved applicants ({{ send_response_approved_list.length }}):</h3>
                    <span :class="[ !permission_recruitment?.editEmailTemplates?.permission && 'not-allowed-btn']" @click="openEdit('edit_template_approved')">View / Edit Template</span>
                </dt>
                <dd class="alert" v-if="info.auto_send_decision_approved">
                    <svg-icon name="alert" />
                    Your emails are scheduled to be delivered on {{ moment(schedule_approved_date).format('MMM DD, YYYY') }} at {{ moment(schedule_approved_date).format('h:mma') }} (UTC). By clicking "Send" below - you will be sending response emails before your scheduled date. You can adjust your scheduled date in your 
                    <span :class="[ !permission_recruitment?.editEmailTemplates?.permission && 'not-allowed-btn']" @click="openEdit('email_settings')">email settings</span>. 
                </dd>
                <dd class="item" v-for="(item, index) in send_response_approved_list" :key="index">
                    <span>{{ item.first_name + ' ' + item.last_name }}</span> <i @click="removeTodoItem(item)"><svg-icon name="stop" /></i>
                </dd>
            </dl>
            <dl v-if="send_response_rejected_list.length !== 0">
                <dt>
                    <h3>To all selected rejected applicants ({{ send_response_rejected_list.length }}):</h3>
                    <span :class="[ !permission_recruitment?.editEmailTemplates?.permission && 'not-allowed-btn']" @click="openEdit('edit_template_rejected')">View / Edit Template</span>
                </dt>
                <dd class="alert" v-if="info.auto_send_decision_reject">
                    <svg-icon name="alert" />
                    Your emails are scheduled to be delivered on {{ moment(schedule_reject_date).format('MMM DD, YYYY') }} at {{ moment(schedule_reject_date).format('h:mma') }} (UTC). By clicking "Send" below - you will be sending response emails before your scheduled date. You can adjust your scheduled date in your 
                    <span :class="[ !permission_recruitment?.editEmailTemplates?.permission && 'not-allowed-btn']"  @click="openEdit('email_settings')">email settings</span>. 
                </dd>
                <dd class="item" v-for="(item, index) in send_response_rejected_list" :key="index">
                    <span>{{ item.first_name + ' ' + item.last_name }}</span> <i @click="removeTodoItem(item)"><svg-icon name="stop" /></i>
                </dd>
            </dl>

            <div class="send-yourself">
                <label @click="is_send_yourself_response = !is_send_yourself_response"><Checkbox :checked="is_send_yourself_response" /> Send a copy to yourself <span>({{ $store.state.user_data.email }})</span></label><br>
                <span>Send me a test ({{ $store.state.user_data.email }})</span>
            </div>
        </div>
        <div class="col" v-else>
            <p class="small-text">We will send emails to those who have not previously been sent.  </p>
            <p class="msg">You can set up a schedule and/or automate your emails in the <span :class="[ !permission_recruitment?.editEmailTemplates?.permission && 'not-allowed-btn']" @click="openEdit('email_settings')">email settings</span>.</p>
            <dl v-if="send_invite_list.length !== 0">
                <dt>
                    <h3>To all selected applicants({{ send_invite_list.length }}):</h3>
                    <span :class="[ !permission_recruitment?.editEmailTemplates?.permission && 'not-allowed-btn']" @click="openEdit('edit_template_invite')">View / Edit Template</span>
                </dt>
                <dd class="alert" v-if="info.auto_send_storefront_invitation">
                    <svg-icon name="alert" />
                    Your emails are scheduled to be delivered on {{ moment(schedule_invite_date).format('MMM DD, YYYY') }} at {{ moment(schedule_invite_date).format('h:mma') }} (UTC). By clicking "Send" below - you will be sending response emails before your scheduled date. You can adjust your scheduled date in your 
                    <span :class="[ !permission_recruitment?.editEmailTemplates?.permission && 'not-allowed-btn']" @click="openEdit('email_settings')">email settings</span>. 
                </dd>
                <dd class="item" v-for="(item, index) in send_invite_list" :key="index">
                    <span>{{ item.first_name + ' ' + item.last_name }}</span> <i @click="removeTodoItem(item)"><svg-icon name="stop" /></i>
                </dd>
            </dl>

            <div class="send-yourself">
                <label @click="is_send_yourself_invite = !is_send_yourself_invite"><Checkbox :checked="is_send_yourself_invite" /> Send a copy to yourself <span>({{ $store.state.user_data.email }})</span></label><br>
                <span>Send me a test ({{ $store.state.user_data.email }})</span>
            </div>
        </div>
        <footer>
            <p>
                <span :class="[ 'edit-btn' ,!permission_recruitment?.editEmailTemplates?.permission && 'not-allowed-btn']" @click="openEdit()"><svg-icon name="edit" /></span>
            </p>
            <Button @click="is_show_send_modal = false" :style="'border-square'" color="dark-blue" size="32">Back</Button>
            <Button :style="'bg-square'" color="dark-blue" size="32" :is_disabled="(send_invite_list.length + send_response_list.length) === 0" @click="sendEmail()">Send</Button>
        </footer>
    </Modal>
    <Modal :is_show="is_show_alert_modal" @click-bg="is_show_alert_modal = false" class="send-email-modal">
        <!-- <header>
            <h2>{{ send_email_type === 'response' ? 'Send: Application Response' : 'Send: Storefront - Invite' }}</h2>
        </header> -->
        <div class="col">
            <dl v-if="alert_items.filter((o) => o.decision_status === 100).length !== 0">
                <dt>
                    <h2>The following applicant(s) have been Approved and may have received a notification - are you sure you want to change their status?</h2>
                </dt>
                <dd class="item" v-for="(item, index) in alert_items.filter((o) => o.decision_status === 100)" :key="index">
                    <span>{{ item.first_name + ' ' + item.last_name }}</span>
                </dd>
            </dl>
            <dl v-if="alert_items.filter((o) => o.decision_status === -10).length !== 0">
                <dt>
                    <h2>The following applicant(s) have been Rejected and may have received a notification - are you sure you want to change their status?</h2>
                </dt>
                <dd class="item" v-for="(item, index) in alert_items.filter((o) => o.decision_status === -10)" :key="index">
                    <span>{{ item.first_name + ' ' + item.last_name }}</span>
                </dd>
            </dl>
        </div>
        <footer>
            <p>
            </p>
            <Button @click="is_show_alert_modal = false" :style="'border-square'" color="dark-blue" size="32">Cancel</Button>
            <Button :style="'bg-square'" color="dark-blue" size="32" @click="sendAlertEmail()">Confirm</Button>
        </footer>
    </Modal>
    <ApplicationModalSide 
        v-if="current_info" 
        ref="modal" 
        :info="current_info" 
        :key="current_info.id"
        :is_show_obj="info"
        @update-decision-status="updateSideDecision"
        @send-email="sendInEmail"
    />
    <Modal :is_show="is_show_edit" class="edit-settings-modal" @click-bg="resetEditModalData()">
        <Loading class="static" v-if="is_loading_edit_data"/>
        <EditModal
            v-else
            :data="edit_data" 
            :type="'edit'" 
            :application_status="info.status_name"
            :ambassador_application_id="info.ambassador_application_id"
            :title="info.title"
            :is_edit="true"
            @update-data="updateSettings"
            @close="resetEditModalData()"
            @save="saveSettings"
            ref="edit"
        />
    </Modal>
    <Modal :is_show="is_date_exceeded" class="alert-modal exceeded-modal" @click-bg="is_date_exceeded = false">        
        <div class="box">
            <span class="close" @click="is_date_exceeded = false"><svg-icon name="close" /></span>
            <i><svg-icon name="alert2" /></i>
            <h2>Immediate Action Required</h2>
            <!-- this.is_approved_date_exceeded || this.is_reject_date_exceeded || this.is_invite_date_exceeded; -->
            <p v-if="is_invite_date_exceeded">Your scheduled emails have expired. Please choose to send them now or update the scheduled delivery time.</p>
            <p v-else>Your scheduled {{is_reject_date_exceeded?'rejection':'approval'}} emails have sent and new applicant responses are sending immediately. To update the scheduled delivery time, click<span class="strong-span"> Reschedule </span>below.</p>
            <div class="btns">
                <Button type="button" :border_r="6" color="dark-blue" size="40" @click="openEdit('email_settings'); is_date_exceeded = false;">Reschedule</Button>
            </div>
        </div>
    </Modal>
    <!-- <Modal :is_show="is_show_max_modal" class="alert-modal" @click-bg="is_show_max_modal = false">        
        <div class="box">
            <header class="delete-header">Maximum storefront allowance reached</header>
            <p>Unable to send more storefront invitesas you've reached your maximum 
            allowance. Excess candidates will not receive invites. 
            Please disable some existing 
            invites or contact support toupdate your allowance.</p>
            <div class="btns">
                <Button type="button" :border_r="6" color="white" size="32" @click="is_show_max_modal = false">Close</Button>
                <Button type="button" :border_r="6" color="dark-blue" size="32" @click="sendEmailToSupport(); is_show_max_modal = false;">Contact Support</Button>
            </div>
        </div>
    </Modal> -->
    <!-- @calendarChange="calendarChange" @timeChange="timeChange" @updateData="updateDataInSide"  -->
    <EditResTemplate ref="editResTemplate" :handle_data="edit_data.settings" @emailSave="emailSave" :ambassador_application_id="info.ambassador_application_id" :ambassador_application_name="info.title"/>
    <notifications class="app-notifications bottom-right" group="app" position="bottom right" @click="handlerClick" id="js-app-notifications" />
    <el-dialog
        v-model="handleUpdateStatus"
        class="updating-dialog"
        width="400px"
        :show-close="false"
    >
        <h3>{{ handleUpdateStatusValue.title }}</h3>
        <p v-html="handleUpdateStatusValue.content"></p>
        
        <div class="btn-footer">
            <el-button type="text" @click="handleUpdateStatus=false">No</el-button>
            <el-button @click="updateDecision({key:handleUpdateStatusValue.type},handleUpdateStatusValue.items,true);" type="primary" :class="[ `dialog-${handleUpdateStatusValue.type}` ]">Yes</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import Button from '@/components/ui/Button.vue';
import Content from '@/components/ui/Content.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Modal from '@/components/ui/Modal.vue';
import Table from '@/components/ui/Table.vue';
import Loading from '@/components/ui/Loading.vue';
import NoData from '@/components/creator/NoData.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import Search from '@/components/ui/Search.vue';
import moment from 'moment';
import FilterDropdown from '@/components/FilterDropdown.vue';
import Pagenavi from '@/components/ui/Pagenavi.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import Share from '@/components/ui/ShareApp.vue';
import ApplicationModalSide from '@/components/programs/ApplicationModalSide.vue';
import EditModal from '@/components/programs/Form/FormFormRight.vue';
import EditResTemplate from '@/components/programs/Form/EditResTemplate.vue';
import { ElDialog,ElButton } from 'element-plus';
// add svg to sprites
require(`@/assets/svg/yes.svg?sprite`);


import { HandleNum, HandleKNum } from '@/utils/SwitchFun';
import { getFormApiData } from '@/utils/ProgramsData.js';

export default {
    name: 'Application',

    data() {
        return {
            is_loading: true,
            is_loading_data: false,
            is_show_email_menu: false,
            is_show_send_modal: false,
            is_send_yourself_response: false,
            is_send_yourself_invite: false,
            is_set_response_time: false,
            is_set_invite_time: false,
            is_show_edit: false,
            is_show_alert_modal: false,
            is_disabled_click: false,
            // is_show_max_modal: false,
            is_updating: false,
            is_update_info: false,
            is_loading_edit_data: true,
            is_auto_send_approved: false,
            is_auto_send_reject: false,
            is_auto_send_invite: false,
            is_date_exceeded: false,
            is_approved_date_exceeded: false,
            is_reject_date_exceeded: false,
            is_invite_date_exceeded: false,
            is_show_msg: true,
            schedule_approved_date: '',
            schedule_reject_date: '',
            schedule_invite_date: '',

            send_email_type: 'response',
            statistic: false,
            info: false,
            data: [],
            edit_data: {},
            edit_data_for_old: {},
            alert_items: [],
            alert_status: 0,
            sort_key: null,
            sort_val: 'desc',
            keyword: '',
            select_pagenum: [
                { id: 1, text: '50/page', val: 50, is_selected: true },
                { id: 2, text: '20/page', val: 20, is_selected: false },
            ],
            params: {
                decision: [],
                submitted: 0,
                storefront_invite: 9999,
                tiktok_followers: {
                    range: 0,
                    min: '',
                    max: '',
                    val: '',
                    msg: '',
                },
                instagram_followers: {
                    range: 0,
                    min: '',
                    max: '',
                    val: '',
                    msg: '',
                },
            },
            storefront_status: [
                { status: 9999, name: 'All', current: true },
                { status: 100, name: 'Active', current: false },
                { status: -10, name: 'Declined', current: false },
                { status: 0, name: 'Disabled', current: false },
                { status: 10, name: 'Added', current: false },
            ],

            recently_submitted: [
                { status: 0, name: 'All time', current: true },
                { status: 3, name: 'Last 3 days', current: false },
                { status: 7, name: 'Last 7 days', current: false },
                { status: 30, name: 'Last 30 days', current: false },
            ],

            active_menu: [
                { key: 0, name: 'To-Do', text: 'To-Do', current: false, class: 'todo', is_disabled: false, },
                { key: 100, name: 'Approve', text: 'Approved', current: true, class: 'approved', is_disabled: false, },
                {
                    key: 1,
                    name: 'Approve & Add to Program',
                    text: 'Approve & Add to Program',
                    current: false,
                    class: 'approved',
                    is_disabled: false,
                },
                
                { key: 10, name: 'Review', text: 'In Review', current: false, class: 'reviewing', is_disabled: false, },
                { key: 20, name: 'Waitlist', text: 'Waitlist', current: false, class: 'waitlist', is_disabled: false, },
                { key: -10, name: 'Reject', text: 'Rejected', current: false, class: 'rejected', is_disabled: false, },
            ],

            hide_fields: {
                tiktok_followers: true,
                instagram_followers: true,
            },

            current_item: false,
            current_info: false,
            current_page: 1,
            total_page: 1,
            page: 1,
            duration: 8000,
            handleUpdateStatus: false,
            handleUpdateStatusValue:{
                type:0,
                title:'Are you sure you want to reject {#} applicants?',
                content:'If you have not scheduled rejection emails in your settings, this will immediately send one to all selected creators.',
                count:0,
                items:[],
            }
        }
    },

    components: {
        Sidebar,
        Button,
        Content,
        Scrollbar,
        Modal,
        Table,
        NoData,
        Loading,
        Dropdown,
        Search,
        Checkbox,
        Pagenavi,
        Share,
        FilterDropdown,
        ApplicationModalSide,
        EditModal,
        EditResTemplate,
        ElButton,
        ElDialog,
    },

    watch: {
        '$route.params': {
            handler() {
                this.data = [];
                this.is_loading = true;

                this.fetchData();
            },
            immediate: true,
        }
    },



    computed: {
        permission_recruitment(){
            return this.$store.state.user_data?.permission_list?.recruitment;
        },
        permission_reports(){
            return this.$store.state.user_data?.permission_list?.reports;
        },
        canNotEdit(){
            return this.permission_recruitment?.approveOrRejectApplicants?.permission !== 100 || this.permission_recruitment?.manageCandidates?.permission !== 100;
        },

        todo_data() {
            return this.data.filter((o) => o.selected === true);
        },

        send_response_list() {
            return this.todo_data.filter((o) => (
                o.decision_status === 100 || 
                o.decision_status === -10) && 
                o.response_email_send_status !== 100
            );
        },

        send_response_approved_list() {
            return this.send_response_list.filter((o) => o.decision_status === 100);
        },

        send_response_rejected_list() {
            return this.send_response_list.filter((o) => o.decision_status === -10);
        },

        send_invite_list() {
            return this.todo_data.filter((o) => (
                o.decision_status === 100 && 
                o.response_email_send_status === 100 && 
                o.storefront_invite_email_send_status !== 30 && 
                o.storefront_invite_email_send_status !== 100 &&
                o.is_duplicate_anchor_creator_id === null
            ));
        },

        // max_creator_count() {
        //     return (this.$store.state.current_creator_count + this.send_invite_list.length) >= this.$store.state.creator_max_count;
        // },

        edit_list() {
            return this.todo_data.filter((o) => !(o.decision_status === 100 && o.response_email_send_status === 100));
        },

        is_empty_data() {
            return !this.is_loading && this.data.length === 0;
        },

        is_filtered() {
            return this.params.submitted !== 0 || 
            this.params.decision.length !== 0 || 
            this.params.storefront_invite !== 9999 || 
            (this.params.tiktok_followers.range !== 2 && this.params.tiktok_followers.val) || 
            (this.params.tiktok_followers.range === 2 && this.params.tiktok_followers.min && this.params.tiktok_followers.max) || 
            (this.params.instagram_followers.range !== 2 && this.params.instagram_followers.val) || 
            (this.params.instagram_followers.range === 2 && this.params.instagram_followers.min && this.params.instagram_followers.max);
        }
    },

    methods: {
        handleNum: HandleNum,
        moment: moment,

        sendEmailToSupport() {
            window.open(`mailto:${this.$store.state.mail_to}?subject=${this.$store.state.user_data.merchant_account ? this.$store.state.user_data.merchant_account.merchant_display_name + ' - ' : ''}Support Request&body=Please%20describe%20your%20issue%20below%20in%20as%20much%20detail%20as%20possible%20(including%20what%20device%20you're%20using%20and%20screenshots,%20if%20necessary).%20A%20support%20team%20member%20will%20contact%20you%20within%201-2%20business%20days.`);
            // this.$router.push('/help');
        },

        toggleMsg(type) {
            switch (type) {
                case 'open':
                    this.is_show_msg = true;
                    window.localStorage.removeItem('application_is_hide_msg');
                    break;

                case 'close':
                    this.is_show_msg = false;
                    window.localStorage.setItem('application_is_hide_msg', '1');
                    break;
            }
        },
        
        handlerClick(data) {

            setTimeout(() => {
                if (this.is_disabled_click) {
                    this.is_disabled_click = false;
                    return;
                }

                if (data.data) {
                    switch (data.data.type) {
                        case 'email':
                            this.sendEmailToSupport();
                            break;

                        case 'approved':
                        case 'rejected':
                            if ((data.data.type === 'approved' && this.send_response_approved_list.length !== 0) || (data.data.type === 'rejected' && this.send_response_rejected_list.length !== 0)) {
                                this.is_show_send_modal = true;
                            }
                            break;

                        case 'update_decision_approved':
                        case 'update_decision_rejected':
                            this.openEdit('email_settings');
                            break;
                    }
                }
            }, 100);
        },

        setDate() {
            const start = this.info.application_start;
            const end = this.info.application_end;

            let hsdate = start === '0000-00-00 00:00:00' ? '' : this.moment(start).format('MMM DD, YYYY');
            let hedate = end === '0000-00-00 00:00:00' ? '' : this.moment(end).format('MMM DD, YYYY');
            
            if (this.info.status === 100) {
                return `${!hsdate ? this.moment(this.info.created_at).format('MMM DD, YYYY'): hsdate} - ${!hedate ? 'Open' : hedate}`;
            }else{
                return `${!hsdate ? this.moment(this.info.created_at).format('MMM DD, YYYY'): hsdate} - ${hedate ?  hedate : 'Open'}`;
            }
        },


        sendInEmail(obj) {
            this.is_update_info = obj.item.id;
            this.resend(obj.item, obj.type, true);
        },

        openEditResForm(type, is_edit_template = false) {

            setTimeout(() => {
                if (is_edit_template) {
                    let index = 0;
                    switch (type) {
                        case 'edit_template_approved':
                            index = 3;
                            break;
                            
                        case 'edit_template_rejected':
                            index = 4;
                            break;

                        case 'edit_template_invite':
                            index = 5;
                            break;
                    }

                    this.$refs.editResTemplate.gotoEditEmail(index, true);
                } else {
                    this.$refs.edit.openForm(type);
                }
            }, 10);
        },

        emailSave(data) {
            // console.log(data);
            // console.log(this.edit_data.settings);
            this.saveSettings(this.edit_data);
        },

        openEdit(type = 'all') {
            const is_edit_template = type === 'edit_template_approved' || type === 'edit_template_rejected' || type === 'edit_template_invite';
            if (!is_edit_template) this.is_show_edit = true;
            // console.log(type)
            
            if (!this.is_loading_edit_data) {
                this.openEditResForm(type, is_edit_template);
            } else {
                this.getFormData(() => {
                    this.openEditResForm(type, is_edit_template);
                });
            }
        },

        openEditForm() {
            //this.EventBus.emit('open-form-setting',{data:{},type:'edit', pick_id: this.info.ambassador_application_id});
            this.$store.state.program_data.is_preview= false;
            this.$router.push(`/programs/application/edit/${this.info.ambassador_application_id}`);
        },

        updateSettings(data) {
            console.log('updateSettings', data);
        },

        saveSettings(obj) {
            // console.log(obj); return;

            const handleToBack = (obj, type) => {
                const filtArr = obj.filter(e => { return e.can_edit });

                return filtArr.map(e => {

                    switch (type) {
                        case 1:
                            console.log(e);
                            return {
                                ...e,
                                is_required: e.is_switch,
                                show: e.is_switch, 
                                question: e.question.map(ee => {
                                    return {
                                        label: ee.label,
                                        label_type: ee.label_type,
                                        input_value: ee.client_view && ee.client_view.val ? ee.client_view.val : ee.val ? ee.val:'',
                                        show: typeof ee.is_switch !== 'undefined' ? ee.is_switch : true,
                                    }
                                })
                            }

                        case 2:
                            if (e.group_name !== 'parent_guardian_introduction') e.is_switch = true;

                            return {
                                ...e,
                                is_required: e.is_switch,
                                show: e.is_switch,
                                question: e.question.map(ee => {
                                    return {
                                        label: ee.label,
                                        label_type: ee.label_type,
                                        input_value: ee.client_view && ee.client_view.val ? ee.client_view.val : ee.val ? ee.val:'',
                                        show: e.is_switch,
                                    }
                                })
                            }
                    }

                })
            };

            const handleToBackSetting = () =>{
                const settings_data = obj.settings.filter(e => { return !e.not_use });

                return settings_data.map(e=>{
                        let filterSectionGroup=e.section_groups.filter(ee=>{ return !ee.not_use });
                        return{
                            ...e,
                            section_groups:filterSectionGroup.map(ee=>{
                                return{
                                    ...ee,
                                    group_setting:ee.group_setting.map(item=>{

                                        //handle input_value
                                        let input_value='';
                                        //多選的input_value要另外處理
                                        if(item.input_type==='multi_select'){
                                            if(item.client_view && item.client_view.val){

                                                if(item.input_type==='multi_select'){
                                                    input_value=[];
                                                    item.client_view.val.forEach(value=>{
                                                        input_value.push(value.text);
                                                    })
                                                }else{
                                                    input_value=item.client_view.val;
                                                }

                                            }else if(item.input_value){
                                                input_value=item.input_value;
                                            }
                                        }else{
                                            if(item.input_value && item.tag ==='only_input_value'){
                                                input_value=item.input_value;
                                            }else if(item.client_view && item.client_view.val){
                                                input_value=item.client_view.val;
                                            }
                                        }

                                        //信箱另外處理
                                        if((item.label==='thank_you_message' || item.is_email) && ee.is_switch ){
                                            input_value=input_value?input_value: item.client_view.plac;
                                        }
                                        //-------------------------------------------

                                        return{
                                            label: item.label,
                                            label_type: item.label_type,
                                            show: item.client_view && item.client_view.show === false || ee.is_switch === false ? false: true,
                                            input_value:input_value,
                                    }
                                }),
                                show:ee.is_switch === false ? ee.is_switch: true,
                            }
                        })
                    }
                });
            };

            let parent_guardian_consent = [];
            let agreements_disclaimers = handleToBack(obj.agreements_disclaimers, 1);
            //agreements_disclaimers有前端hardcode的欄位，要特別移除
            agreements_disclaimers.forEach((e, k) => {
                if (k === 0) { 
                    e.question = e.question.filter(item => item.label !== 'anchor_term' && item.label !== 'sephora_term');
                }
            });

            if (obj.is_open) {
                parent_guardian_consent = handleToBack(obj.parent_guardian_consent, 2);
            }

            const form_data = {
                application_id: this.info.ambassador_application_id,
                parent_guardian_consent: parent_guardian_consent,
                agreements_disclaimers: agreements_disclaimers,
                settings: handleToBackSetting(),
            }

            this.is_updating = true;

            this.$ajax( '/ambassador/update-application-setting', {
                method: 'post',
                data: form_data,
            }).then(res => {
                this.is_updating = false;
                this.is_show_edit = false;
                this.getFormData(false);
                this.getData(true);

                const ids = this.todo_data.map((o) => o.id);
                this.fetchData(ids);
                this.$notify({
                    type: 'success',
                    group: 'app',
                    text: `<p style="width: 380px;">
                            <svg><use xlink:href="#yes--sprite"></use></svg> 
                            <span class="text">Application updated.</span>
                            </p>`,
                    duration: this.duration,
                });

            }).catch(err => {

                this.is_updating = false;
                this.$notify({
                    title: `<svg class="alert"><use xlink:href="#alert--sprite"></use></svg> ${err.response.data.message || err.response.data.data.message}`,
                    type: 'warn',
                    duration: 5000,
                    group: 'center',
                });
            });
        },

        getFormData(cb) {
            this.$ajax('/ambassador/get-application-data?ambassador_application_id=' + this.$route.params.application_id, {
                method: 'get',
            }).then(res => {
                this.edit_data = getFormApiData(res.data.data,this);
                this.edit_data_for_old = JSON.parse(JSON.stringify( this.edit_data ));
                this.is_loading_edit_data = false;

                if (cb) cb();
            })
        },

        openSendModal(type) {
            this.send_email_type = type;

            if (type === 'response_externally' || type === 'invite_externally') {
                this.sendEmail();
            } else {
                this.is_show_send_modal = true;
            }

        },

        removeTodoItem(item) {
            item.selected = false;
        },

        resend(row, type, is_open = false) {
            if (this.$refs.menu) this.$refs.menu.style.display = 'none';
            // console.log(row.storefront_invite_email_send_status)
            if (is_open || 
                (type === 'response' && row.response_email_send_status === -10) || 
                (type === 'response_externally' && row.response_email_send_status === -10) || 
                (type === 'response' && (row.decision_status === 100 || row.decision_status === -10) && row.response_email_send_status === 0) || 
                (type === 'response_externally' && (row.decision_status === 100 || row.decision_status === -10) && row.response_email_send_status === 0) || 
                (type === 'invite' && row.storefront_invite_email_send_status === -10) || 
                (type === 'invite_externally' && row.storefront_invite_email_send_status === -10) || 
                (type === 'invite' && row.storefront_invite_email_send_status === 20 && row.is_duplicate_anchor_creator_id === null) || 
                (type === 'invite_externally' && row.storefront_invite_email_send_status === 20 && row.is_duplicate_anchor_creator_id === null)
            ) {
                this.data.forEach(item => {
                    if (item.id === row.id) {
                        item.selected = true;
                    } else {
                        item.selected = false;
                    }
                });

                this.send_email_type = type;
                this.sendEmail();

                // setTimeout(() => {
                //     this.openSendModal(type);
                // }, 100);
            } else {
                this.open(row);
            }
        },

        sendEmail() {
            this.is_show_send_modal = false;

            const type = this.send_email_type === 'response' || this.send_email_type === 'response_externally' ? 'decision' : 'storefront_invitation';
            let ids = [];
            let is_send_copy = 0;

            if (type === 'decision') {
                ids = this.send_response_list.map((o) => o.id);
                is_send_copy = this.is_send_yourself_response ? 1 : 0;
            } else {
                ids = this.send_invite_list.map((o) => o.id);
                is_send_copy = this.is_send_yourself_invite ? 1 : 0;
            }

            this.is_updating = true;
            const obj = {
                ambassador_user_application_record_ids: ids,
                email_general_type: type,
                is_send_copy: is_send_copy,
                send_all_emails_from_external: this.send_email_type === 'response_externally' || this.send_email_type === 'invite_externally' ? 1 : 0,
            };

            // console.log('obj', this.send_email_type, obj);
            // return;

            this.$ajax('/ambassador/send-email', {
                method: 'post',
                data: obj
            }).then(res => {
                if (res.data.status === 'success') {
                    let text = '';
                    if (type !== 'storefront_invitation') {
                        text = `<p><svg><use xlink:href="#yes--sprite"></use></svg><span class="text">${ids.length} email${ ids.length > 1 ? 's' : '' } sent successfully</span><span class="close"><svg><use xlink:href="#close--sprite"></use></svg></span></p>`;
                    } else {
                        text = `<p><svg><use xlink:href="#yes--sprite"></use></svg><span class="text">${ids.length} invite${ ids.length > 1 ? 's' : '' } sent successfully</span><span class="close"><svg><use xlink:href="#close--sprite"></use></svg></span></p>`;
                    }

                    this.$notify({
                        type: 'success',
                        text: text,
                    });

                    this.is_updating = false;

                    this.fetchData();

                    // this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Email sent successfully.`);
                }
            });

            
        },
        
        responseStyle(row) {
            // console.log('row', row.decision_status)
            if (row.decision_status === 0) return '<span class="n-a">---</span>';

            switch (row.response_email_send_status) {
                case 100:
                    return `<span class="status-text status-success">Sent</span>
                            <p><time>${moment(row.response_email_send_actions.show_date).format('MMM DD, YYYY')}</time></p>`;
                    
                // case 0:
                //     return `<span class="status-text status-na">${row.response_email_send_status_text}</span>
                //     ${(row.decision_status === 100 || row.decision_status === -10) ? '<p><span class="blue js-link">Send decision</span></p>' : ''}
                //     `;
                case 0:
                    return `<span class="status-text status-na">${row.response_email_send_status_text}</span>`;

                // case -10:
                //     return `<span class="status-text status-failed">${row.response_email_send_status_text}</span>
                //             <p><span class="blue js-link">Resend</span></p>`;
                case -10:
                    return `<span class="status-text status-failed">${row.response_email_send_status_text}</span>`;
                
                case 10:
                    const schedule_date = row.decision_status === 100 ? this.schedule_approved_date : this.schedule_reject_date;
                    return `<span class="status-text status-scheduled">${row.response_email_send_status_text}</span>
                            <p><time class="blue">${moment(schedule_date).format('MMM DD, YYYY')}</time></p>`;

                default:
                    return row.response_email_send_status_text + '-' + row.response_email_send_status;
            }
        },

        inviteStyle(row) {
            if (row.decision_status === 0) return '<span class="n-a">---</span>';
            
            switch (row.storefront_invite_email_send_status) {
                case 100:
                    return `<span class="status-text status-success">${row.storefront_invite_email_send_status_text}</span>
                            <p><time>${moment(row.storefront_invite_email_send_actions.show_date).format('MMM DD, YYYY')}</time></p>`;

                case 0:
                    if (row.decision_status === 100 && (row.response_email_send_status === 100 || row.response_email_send_status === 10) && !this.is_auto_send_invite && this.schedule_invite_date) return `<span class="status-text status-scheduled">Scheduled</span>
                        <p><time class="blue">${moment(this.schedule_invite_date).format('MMM DD, YYYY')}</time></p>`;
                    else return `<span class="status-text status-na">${row.storefront_invite_email_send_status_text}</span>`;


                // case -10:
                //     return `<span class="status-text status-failed">${row.storefront_invite_email_send_status_text}</span>
                //             <p><span class="blue js-link">Resend</span></p>`;
                case -10:
                    return `<span class="status-text status-failed">${row.storefront_invite_email_send_status_text}</span>`;

                case 10:
                    return `<span class="status-text status-scheduled">${row.storefront_invite_email_send_status_text}</span>
                        <p><time class="blue">${moment(this.schedule_invite_date).format('MMM DD, YYYY')}</time></p>`;
                       
                // case 20:
                //     if (row.is_duplicate_anchor_creator_id !== null) {
                //         return `<span class="status-text status-${row.anchor_creator.anchor_page_status === 100 ? 'success' : 'scheduled'}">
                //                 ${row.anchor_creator.anchor_page_status_text}
                //             </span>`;
                //     } else {
                //         return `<span class="status-text status-scheduled">${row.storefront_invite_email_send_status_text}</span>
                //         <p><span class="blue js-link">Send invite</blue></p>`;
                //     }
                case 20:
                    if (row.is_duplicate_anchor_creator_id !== null) {
                        return `<span class="status-text status-${row.anchor_creator?.anchor_page_status === 100 ? 'success' : 'scheduled'}">
                                ${row.anchor_creator?.anchor_page_status_text}
                            </span>`;
                    } else {
                        return `<span class="status-text status-scheduled">${row.storefront_invite_email_send_status_text}</span>`;
                    }

                case 30:
                    return `<span class="status-text status-invited">${row.storefront_invite_email_send_status_text}</span>
                        <p><time class="blue">${moment(row.storefront_invite_email_send_actions.show_date).format('MMM DD, YYYY')}</time></p>`;

                default:
                    return row.storefront_invite_email_send_status_text + '-' + row.storefront_invite_email_send_status;
            }
        },

        open(row) {
            if(this.permission_recruitment?.viewApplicantDetails?.permission !== 100) return;
            this.current_info = row;
            
            setTimeout(() => {
                this.$refs.modal.open();
            }, 10);
            // this.$router.push({ name: 'creator-application-detail', params: { application_id: row.application_record_id } });
        },

        gotoPage(page) {
            this.page = page;
            this.fetchData();
        },

        updatePagenum(item) {
            this.select_pagenum.forEach((o) => {
                o.is_selected = (o.id === item.id);
            });

            this.fetchData();
        },

        updateSideDecision(obj) {
            // console.log('obj', obj);
            this.updateDecision(obj.status, [obj.item],false, 'is_inside_change');
        },

        updateDecisionStatus(status) {
            // console.log(status)
            this.$refs.menu.style.display = 'none';

            if (this.current_item === 'all') {
                let update_list = [];
                this.edit_list.forEach(item => {
                    if (status.key === 0 && item.decision_status === 10) {
                        update_list.push(item);
                    } 
                    else if (status.key === 0 && (item.decision_status === 100 && item.response_email_send_status !== 100)) {
                        update_list.push(item);
                    } 
                    else if (status.key !== 0 && status.key !== item.decision_status) {
                        update_list.push(item);
                    }
                });
                

                if (update_list.length !== 0) {
                    if (status.key === 1) {
                        this.updateDecision(status, update_list);
                    }
                    else if (update_list.filter((o) => o.decision_status === 100).length !== 0 || update_list.filter((o) => o.decision_status === -10).length !== 0) {
                        this.alert_items = update_list;
                        this.alert_status = status;
                        this.is_show_alert_modal = true;
                    } else {
                        this.updateDecision(status, update_list);
                    }
                }

            } else {
                if (this.current_item.decision_status === status.key) return;
                if (status.key === 1) {
                    this.updateDecision(status, [this.current_item]);
                }
                else if (this.current_item.decision_status === -10 || this.current_item.decision_status === 100) {
                    this.alert_items = [this.current_item];
                    this.alert_status = status;
                    this.is_show_alert_modal = true;
                } else {
                    this.updateDecision(status, [this.current_item]);
                }
            }
        },

        sendAlertEmail() {
            this.is_show_alert_modal = false;
            this.updateDecision(this.alert_status, this.alert_items);
        },

        openHandleStatusPopup(status, items = [], isInsideChange){
            this.handleUpdateStatusValue.count=items.length;
            this.handleUpdateStatusValue.items=items;
            this.handleUpdateStatusValue.type=status.key;
            this.handleUpdateStatusValue.specVal= isInsideChange;
            switch (status.key) {
                case -10:
                    this.handleUpdateStatusValue.title=`Are you sure you want to reject ${items.length} applicants?`;
                    this.handleUpdateStatusValue.content=`If you have not scheduled rejection emails in your settings, this will <span class='strong'>immediately</span> send one to all selected creators.`;
                    break;
                case 100:
                    this.handleUpdateStatusValue.title=`Are you sure you want to approve ${items.length} applicants?`;
                    this.handleUpdateStatusValue.content=`If you have not scheduled approval emails in your settings, this will <span class='strong'>immediately</span> send one to all selected creators. This action cannot be undone.`;
                    break;
                case 1:
                    this.handleUpdateStatusValue.title=`Are you sure you want to approve ${items.length} applicants?`;
                    this.handleUpdateStatusValue.content=`If you have not scheduled approval emails in your settings, this will <span class='strong'>immediately</span> send one to all selected creators. This action cannot be undone.`;
                    break;
                case 20:
                    this.handleUpdateStatusValue.title=`Are you sure you want to waitlist ${items.length} applicants?`;
                    this.handleUpdateStatusValue.content=`This will not trigger any emails.`;
                    break;
            }
           
            this.handleUpdateStatus=true;
        },

        updateDecision(status, items = [] , passfirst ,isInsideChange) {
            if((status.key === 100 || status.key === 1 || status.key === -10 || status.key === 20 )&& !passfirst && items.length > 1){
                this.openHandleStatusPopup(status, items , isInsideChange);
                return;
            }
            if(passfirst){
                this.handleUpdateStatus=false;
            };
            if(this.handleUpdateStatusValue.specVal || isInsideChange){
                this.current_info.decision_status = status.key;
                this.$refs.modal.updateStatus();
            }
            // let update_ids = [];
            const ids = items.map((o) => o.id);

            if (status.key === 100 || status.key === -10 || status.key === 1) {
                items.forEach(item => {
                    // item.selected = true;
                    this.data.forEach(data => {
                        if (data.id === item.id) {
                            data.selected = true;
                        } else {
                            data.selected = false;
                        }
                    });
                });
            }

            const obj = {
                ambassador_user_application_record_ids: ids,
                decision_status: status.key === 1 ? 100 : status.key,
                send_all_emails_from_external: status.key === 1 ? 1 : 0,
            };
            
            this.is_updating = true;
            this.$ajax('/ambassador/application-user-record/set-decision', {
                method: 'post',
                data: obj
            }).then(res => {
                if (res.data.status === 'success') {
                   
                    this.getStatistic();
                    this.is_updating = false;
                    let s = items.length > 1 ? 's' : '';

                    let msgs = [];

                    this.fetchData(ids, () => {
                        switch (status.key) {
                            case 1:
                                    msgs.push({
                                        type: 0,
                                        text: `<p style="width: 380px;"><svg><use xlink:href="#yes--sprite"></use></svg><span class="text">Added to creator management successfully</span><span class="close"><svg><use xlink:href="#close--sprite"></use></svg></span></p>`
                                    });
                                break;  


                            case 100:
                                let is_show_msg = false;
                                if (this.is_auto_send_approved) {
                                    msgs.push({
                                        type: 0,
                                        text: `<p style="width: 380px;"><svg><use xlink:href="#yes--sprite"></use></svg><span class="text">${items.length} application${s} approved, and response email${s} have been sent successfully</span><span class="close"><svg><use xlink:href="#close--sprite"></use></svg></span></p>`
                                    });
                                } else if (this.is_approved_date_exceeded) {
                                    is_show_msg = true;
                                    
                                    msgs.push({
                                        type: 1,
                                        text: `<p style="width: 520px;"><svg class="alert"><use xlink:href="#alert--sprite"></use></svg><span class="text">
                                            ${items.length} email response${s} ${this.is_invite_date_exceeded ? ' & invite' + s : ''} failed to schedule due to an expired scheduling date.
                                            </span><span class="btn">Update</span><span class="close"><svg><use xlink:href="#close--sprite"></use></svg></span></p>`,
                                        data: {
                                            type: 'update_decision_approved',
                                        }
                                    });
                                } else if (this.schedule_approved_date) { 
                                    msgs.push({
                                        type: 2,
                                        text: `<p style="width: 380px;"><svg><use xlink:href="#yes--sprite"></use></svg><span class="text">${items.length} application${s} approved, and response email${s} have been scheduled successfully.</span><span class="close"><svg><use xlink:href="#close--sprite"></use></svg></span></p>`,
                                    });
                                } else {
                                    msgs.push({
                                        type: 4,
                                        text: `<p style="width: 380px;"><span class="text">${items.length} application${s} approved</span>${this.send_response_approved_list.length !== 0 ? '<span class="btn">Send via email</span>' : ''}<span class="close"><svg><use xlink:href="#close--sprite"></use></svg></span></p>`,
                                        data: {
                                            type: 'approved',
                                        }
                                    });
                                }

                                if (!is_show_msg) {
                                    if (this.is_auto_send_invite) {
                                        msgs.push({
                                            type: 10,
                                            text: `<p style="width: 380px;"><svg><use xlink:href="#yes--sprite"></use></svg><span class="text">${items.length} invite${s} sent successfully</span><span class="close"><svg><use xlink:href="#close--sprite"></use></svg></span></p>`
                                        });
                                    } else if (this.is_invite_date_exceeded) {
                                        msgs.push({
                                            type: 11,
                                            text: `<p style="width: 380px;"><svg class="alert"><use xlink:href="#alert--sprite"></use></svg><span class="text">${items.length} invite${s} failed to schedule due to an expired scheduling date.</span><span class="btn">Update</span><span class="close"><svg><use xlink:href="#close--sprite"></use></svg></span></p>`,
                                            data: {
                                                type: 'update_decision_approved',
                                            }
                                        });
                                    } else if (this.schedule_invite_date) {
                                        msgs.push({
                                            type: 12,
                                            text: `<p style="width: 380px;"><svg><use xlink:href="#yes--sprite"></use></svg><span class="text">${items.length} invite${s} scheduled successfully.</span><span class="close"><svg><use xlink:href="#close--sprite"></use></svg></span></p>`,
                                        });
                                    }
                                }
                                

                                break;
                            case 0:
                                // text = '';
                                break;
                                
                            case -10:
                                if (this.is_auto_send_reject) {
                                    msgs.push({
                                        type: 5,
                                        text: `<p style="width: 380px;"><svg><use xlink:href="#yes--sprite"></use></svg><span class="text">${items.length} application${s} rejected, and response email${s} have been sent successfully</span><span class="close"><svg><use xlink:href="#close--sprite"></use></svg></span></p>`
                                    })
                                } else if (this.is_reject_date_exceeded) {
                                    msgs.push({
                                        type: 6,
                                        text: `<p style="width: 380px;"><svg class="alert"><use xlink:href="#alert--sprite"></use></svg><span class="text">${items.length} email response${s} failed to schedule due to an expired scheduling date.</span><span class="btn">Update</span><span class="close"><svg><use xlink:href="#close--sprite"></use></svg></span></p>`,
                                        data: {
                                            type: 'update_decision_rejected',
                                        }
                                    });
                                } else if (this.schedule_reject_date) {
                                    msgs.push({
                                        type: 7,
                                        text: `<p style="width: 380px;"><svg><use xlink:href="#yes--sprite"></use></svg><span class="text">${items.length} application${s} rejected, and response email${s} have been scheduled successfully.</span><span class="close"><svg><use xlink:href="#close--sprite"></use></svg></span></p>`,
                                    });
                                } else {
                                    msgs.push({
                                        type: 8,
                                        text: `<p style="width: 380px;"><span class="text">${items.length} application${s} rejected</span>${this.send_response_rejected_list.length !== 0 ? '<span class="btn">Send via email</span>' : ''}<span class="close"><svg><use xlink:href="#close--sprite"></use></svg></span></p>`,
                                        data: {
                                            type: 'rejected',
                                        }
                                    });
                                }
                                
                                break;
                            case 10:
                                // text = '';
                                break;
                            case 20:
                                // text = '';
                                break;
                        }


                        if (msgs.length !== 0) {
                            
                            msgs.forEach(msg => {
                                const obj = {
                                    type: 'success',
                                    text: msg.text,
                                    group: 'app',
                                    duration: this.duration,
                                };

                                if (msg.data) {
                                    obj.data = msg.data;
                                }

                                this.$notify(obj);
                            });

                        }
                    });

                }
            });
        },

        openMenu(row, e) {
            if ((this.current_item === 'all' || this.current_item.id === row.id) && this.$refs.menu && this.$refs.menu.style.display === 'block') {
                this.$refs.menu.style.display = 'none';
                return;
            }

            if (row === 'all') {
                let decision_status = [];

                this.edit_list.forEach(item => {
                    if (!decision_status.includes(item.decision_status)) decision_status.push(item.decision_status);
                });

                this.active_menu.forEach(item => {
                    item.is_disabled = false;
                    item.current = false;

                    if (decision_status.length === 1 && decision_status.includes(item.key)) {
                        item.current = true;
                    }

                    if ((decision_status.includes(-10) || decision_status.includes(20)) && !decision_status.includes(10)) {
                        if (item.key === 0) item.is_disabled = true;
                    }
                });
            } else {
                // Decision status cannot be changed as an email or storefront invite has been sent to the candidate.
                if (row.decision_status === 100 && row.response_email_send_status === 100) {
                    const obj = {
                        type: 'alert',
                        data: {
                            'type': 'email',
                        },
                        text: `
                            <p style="width: 500px;">
                                <svg class="alert"><use xlink:href="#alert--sprite"></use></svg>  
                                <span class="text">Decision status cannot be changed as an email or storefront invite has been sent to the candidate.</span>
                                <span class="btn">Contact us</span>
                                <span class="close"><svg><use xlink:href="#close--sprite"></use></svg></span>
                            </p>
                            
                        `,
                        group: 'app',
                        duration: this.duration,
                    };

                    this.$notify(obj);
                    return;
                }

                this.active_menu.forEach(item => {
                    item.is_disabled = false;
                    item.current = false;

                    if (item.key === row.decision_status) {
                        item.current = true;
                    }
                    
                    if ((row.decision_status === 100 && row.response_email_send_status === 100) || row.storefront_invite_email_send_status === 100) {
                        if (item.key !== 100) item.is_disabled = true;
                    } else if (row.decision_status === -10 || row.decision_status === 20) {
                        if (item.key === 0) item.is_disabled = true;
                    }
                });
            }





            const top = e.clientY;
            const left = e.clientX - 120;


            // check if on the window bottom
            if (window.innerHeight - e.clientY < 200) {
                this.$refs.menu.style.top = (top - 180) + 'px';
            } else {
                this.$refs.menu.style.top = `${top + 10}px`;
            }

            this.current_item = row;
            this.$refs.menu.style.left = `${left}px`;
            this.$refs.menu.style.display = 'block';
        },

        openShare() {
            if(this.$store.state.merchant_disabeld){
                return false;
            }else{
                this.$refs.share.open();
            }

        },

        selectAll(data) {
            let canPickData=data.filter(item=>{
                return !(item.decision_status==100 && item.response_email_send_status == 100)
            })
            if (this.todo_data.length === canPickData.length) {
                data.forEach(item => {
                    item.selected = false;
                });
            } else {
                data.forEach(item => {
                    if(!(item.decision_status==100 && item.response_email_send_status == 100)){
                        item.selected = true;
                    }
                });
            }
        },

        select(data, index) {
            if (this.$refs.menu) this.$refs.menu.style.display = 'none';
            if(data[index].decision_status===100 && data[index].response_email_send_status === 100) return;
            data[index].selected = !data[index].selected;
        },

        search(keyword) {
            this.keyword = keyword;
            this.fetchData();
        },
        
        updateType(item) {
            if (item.field_status === 9999) {
                this.params.decision = [];
            }
            else if (this.params.decision.includes(item.field_status)) {
                this.params.decision = this.params.decision.filter(e => e !== item.field_status);
            } else {
                this.params.decision.push(item.field_status);
            }

            this.fetchData();
        },

        sort(key) {
            if (this.sort_key === key) {
                this.sort_val = this.sort_val === 'asc' ? 'desc' : 'asc';
            } else {
                this.sort_key = key;
                this.sort_val = 'asc';
            }

            this.fetchData();
        },

        getData(is_update = false) {          
            this.$ajax('/ambassador/get-application-user-records/info?ambassador_application_id=' + this.$route.params.application_id, {
                method: 'get',
            }).then(res => {


                const current_utc_date = moment.utc();
                // current_utc_date.format('YYYY-MM-DD HH:mm:ss'),

                // res.data.data.schedule_decision_approved_date = '2024-09-03 02:00:00';
                // res.data.data.schedule_decision_reject_date = '2024-09-03 02:00:00';
                // res.data.data.schedule_storefront_invitation_date = '2024-09-03 02:00:00';
                this.info = res.data.data;
                this.schedule_approved_date = this.info.schedule_decision_approved_date;
                this.schedule_reject_date = this.info.schedule_decision_reject_date;
                this.schedule_invite_date = this.info.schedule_storefront_invitation_date;

                this.is_auto_send_approved = this.info.auto_send_decision_approved && this.schedule_approved_date === null;
                this.is_auto_send_reject = this.info.auto_send_decision_reject && this.schedule_reject_date === null;
                this.is_auto_send_invite = this.info.auto_send_storefront_invitation && this.schedule_invite_date === null;

                if (this.schedule_approved_date) this.is_approved_date_exceeded = current_utc_date.isAfter(moment(this.schedule_approved_date));
                if (this.schedule_reject_date) this.is_reject_date_exceeded = current_utc_date.isAfter(moment(this.schedule_reject_date));
                if (this.schedule_invite_date) this.is_invite_date_exceeded = current_utc_date.isAfter(moment(this.schedule_invite_date));
                if (!is_update) this.is_date_exceeded = this.is_approved_date_exceeded || this.is_reject_date_exceeded || this.is_invite_date_exceeded;

                this.hide_fields.tiktok_followers = this.info.is_show_tiktok_followers_field;
                this.hide_fields.instagram_followers = this.info.is_show_instagram_followers_field;
            }).catch(err => {
                if (err.response.status === 401) {
                    window.location.replace('/programs/applications-list');
                }
            });
            
            this.getStatistic();
        },

        getStatistic() {
            this.$ajax('/ambassador/get-application-user-records/statistic?ambassador_application_id=' + this.$route.params.application_id, {
                method: 'get',
            }).then(res => {

                const order = ['All', 'To-Do', 'Approved', 'Rejected', 'Reviewing', 'Waitlist'];
                this.statistic = res.data.data.sort((a, b) => {
                    return order.indexOf(a.field_status_text) - order.indexOf(b.field_status_text);
                });
            })
        },

        clearFilter(type) {
            switch (type) {
                case 'decision':
                    this.params.decision = [];
                    break;
                case 'response':
                    this.params.submitted = 0;
                    break;
                case 'storefront':
                    this.params.storefront_invite = 9999;
                    break;
                case 'tiktok':
                    this.params.tiktok_followers = {
                        range: 0,
                        min: '',
                        max: '',
                        val: '',
                        msg: '',
                    };
                    break;
                case 'instagram':
                    this.params.instagram_followers = {
                        range: 0,
                        min: '',
                        max: '',
                        val: '',
                        msg: '',
                    };
                    break;
            }

            this.fetchData();
        },
        
        fetchData(ids = [], cb = null) {
            if (!this.is_loading) this.is_loading_data = true;
            let api = `/ambassador/get-application-user-records/list?ambassador_application_id=${this.$route.params.application_id}`;

            // add pagenum
            api += '&per_page=' + this.select_pagenum.find((o) => o.is_selected).val;

            // Use the shared filter builder method
            const filters = this.buildFiltersArray();

            if (filters.length > 0) {
                api += '&filters=' + JSON.stringify(filters);
            }
            
            if (this.page !== 1) {
                api += `&page=${this.page}`;
            }

            if (this.sort_key) {
                api += `&sort_key=${this.sort_key}&sort_val=${this.sort_val}`;
            }

            if (this.keyword) {
                api += `&keyword=${this.keyword}`;
            }
          
            this.$ajax(api, {
                method: 'get',
            }).then(res => {

                this.data = [];
                res.data.data.data.forEach(item => {

                    item.tikTok_followers = HandleKNum(item.tiktok_follower_count);
                    item.instagram_followers = HandleKNum(item.instagram_follower_count);
                    item.submitted = moment(item.submitted).format('MMM DD, YYYY');
                    item.reviewed = moment(item.reviewed).format('MMM DD, YYYY');
                    const status = this.active_menu.find(menu => menu.key === item.decision_status);
                    item.decision_status_text = status.text;
                    item.decision_status_class = status.class;


                    if (ids.length !== 0) {
                        item.selected = ids.includes(item.id);
                    } else {
                        item.selected = false;
                    }
                    // item.selected = false;
                    this.data.push(item);
                });

                // console.log(this.data)


                if (this.is_update_info) {
                    this.current_info = this.data.find(item => item.id === this.is_update_info);
                    this.is_update_info = false;
                }

                this.total_page = res.data.data.last_page;
                this.current_page = res.data.data.current_page;
                this.is_loading = false;
                this.is_loading_data = false;
                
                if (cb) cb();
            })
        },

        resetEditModalData(){
            this.edit_data = JSON.parse(JSON.stringify( this.edit_data_for_old ));
            this.is_show_edit = false;
        },

        buildFiltersArray() {
            const filters = [];

            // Review Status (decision) filters - from shortcut buttons or dropdown
            if (this.params.decision.length !== 0) {
                this.params.decision.forEach(item => {
                    filters.push({ field_name: 'decision', value: item });
                });
            }

            // Recently Submitted filter
            if (this.params.submitted !== 0) {
                filters.push({ field_name: 'submitted', value: this.params.submitted });
            }

            // Storefront Status filter
            if (this.params.storefront_invite !== 9999) {
                filters.push({ field_name: 'storefront_invite', value: this.params.storefront_invite });
            }

            // TikTok followers filter
            if (this.params.tiktok_followers.range !== 2 && this.params.tiktok_followers.val) {
                const obj = { field_name: 'tiktok_follower_count' };
                if (this.params.tiktok_followers.range === 0) {
                    obj.value1 = this.params.tiktok_followers.val;
                } else {
                    obj.value2 = this.params.tiktok_followers.val;
                }
                filters.push(obj);
            } else if (this.params.tiktok_followers.range === 2 && this.params.tiktok_followers.min && this.params.tiktok_followers.max) {
                filters.push({
                    field_name: 'tiktok_follower_count',
                    value1: this.params.tiktok_followers.min,
                    value2: this.params.tiktok_followers.max
                });
            }

            // Instagram followers filter
            if (this.params.instagram_followers.range !== 2 && this.params.instagram_followers.val) {
                const obj = { field_name: 'instagram_follower_count' };
                if (this.params.instagram_followers.range === 0) {
                    obj.value1 = this.params.instagram_followers.val;
                } else {
                    obj.value2 = this.params.instagram_followers.val;
                }
                filters.push(obj);
            } else if (this.params.instagram_followers.range === 2 && this.params.instagram_followers.min && this.params.instagram_followers.max) {
                filters.push({
                    field_name: 'instagram_follower_count',
                    value1: this.params.instagram_followers.min,
                    value2: this.params.instagram_followers.max
                });
            }

            return filters;
        },

        downloadPdf() {
            if(!this.permission_recruitment.viewApplicantDetails.permission  ){
                return;
            }
            this.is_loading=true;

            // Build API URL with all parameters (matching fetchData logic)
            let api = `/ambassador/get-application-user-record-csv-file?ambassador_application_id=${this.info.ambassador_application_id}`;

            // Add filters array as JSON string
            const filters = this.buildFiltersArray();
            if (filters.length > 0) {
                api += '&filters=' + JSON.stringify(filters);
            }

            // Add keyword if exists
            if (this.keyword) {
                api += `&keyword=${this.keyword}`;
            }

            // Add sort parameters if exist
            if (this.sort_key) {
                api += `&sort_key=${this.sort_key}&sort_val=${this.sort_val}`;
            }

            this.$ajax.get(api)
            .then(res => {
                if (res.status == 200) {
                    let name = res.headers['content-disposition'].split('filename=');
                    name = name[1] ? name[1] : 'report';
                    this.$JsDownload(res.data, `${name}.csv`);
                    this.is_loading=false;
                    this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Download Success!`);
                } else {
                    this.is_loading=false;
                    this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Download False!`);
                }
            });
        },
    },

    mounted() {
        if(!this.permission_recruitment.manageApplications.permission){
            this.$router.push({ name: 'creator--list' });
            return;
        }
        if(!this.permission_recruitment.manageCandidates.permission){
            this.$router.push({ name: 'programs--applications-list' });
            return;
        }
        this.getData();
        
        const appNotifications = document.getElementById('js-app-notifications');
        
        // Use event delegation to handle close button clicks
        appNotifications.addEventListener('click', (e) => {
            const closeBtn = e.target.closest('.close');
            if (closeBtn) {
                this.is_disabled_click = true;
                // Find the closest notification element and remove it
                const notification = closeBtn.closest('.vue-notification');
                if (notification) {
                    notification.remove();
                }
            }
        });


        if (window.localStorage.getItem('application_is_hide_msg') !== null) {
            this.is_show_msg = false;
        }

        window.addEventListener('click', (e) => {
            
            let target = e.target;
            let is_active_menu_clicked = false;
            let is_email_menu_clicked = false;

            if (target.classList && target.classList.contains('status-btn')) {
                is_active_menu_clicked = true;
            }

            while (target != null) {
                if (target.classList && target.classList.contains('active-menu')) {
                    is_active_menu_clicked = true;
                }

                if (target.classList && target.classList.contains('email-btn')) {
                    is_email_menu_clicked = true;
                }

                target = target.parentNode;
            }


            if (!is_active_menu_clicked && this.$refs.menu && this.$refs.menu.style.display === 'block') this.$refs.menu.style.display = 'none';
            if (!is_email_menu_clicked && this.is_show_email_menu) this.is_show_email_menu = false;
        });
    },

    beforeDestroy() {
        window.removeEventListener('click', () => {});
    }

}
</script>

<style lang="scss">
.page-programs--application {
    .mx-datepicker-popup {
        z-index: 999900;
    }
}

.application-item-content {
    min-width: 800px;
    
    .download-btn {
        color: var(--black-90);
        height: 32px;
        width: 32px;
        margin-left: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        ;

        svg {
            height: 16px;
            width: 16px;
            display: block;
        }

        &.disabled {
            cursor: not-allowed;

            svg {
                fill: var(--black-20);
            }
        }
    }

    & > .inner {
        height: 100%;
        padding: 0 48px;
        display: grid;
        grid-template-rows: auto auto 1fr;
        grid-template-columns: 100%;
        overflow: hidden;

        .statistic {
            display: flex;
            align-items: flex-start;

            ul {
                display: flex;
                margin: 0 -4px;
                width: calc(100% + 8px);
            }

            li {
                padding: 8px 12px;
                border-radius: 8px;
                width: 16.66%;
                background-color: var(--black-10);
                margin: 0 4px;
                cursor: pointer;
                border: 1px solid var(--black-10);
                transition: all .2s ease-in-out;

                strong {
                    font: var(--font-demi-20);
                    color: var(--black-75);
                    padding-right: 6px;
                }

                span {
                    font: var(--font-med-14);
                    color: var(--black-75);
                }

                &:hover {
                    border-color: var(--dark-blue);
                }

                &.disabled {
                    cursor: not-allowed;
                    opacity: .5;
                    pointer-events: none;
                }

                &.active {
                    background-color: var(--white);
                    border: 1px solid var(--dark-blue);

                    strong {
                        color: var(--dark-blue);
                    }

                    span {
                        color: var(--black-90);
                    }
                }
            }
        }
    }

    .top-bar {
        display: flex;
        margin: 24px -8px 16px -8px;
        align-items: center;

        .back-btn {
            color: var(--dark-gray-blue);
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
            display: flex;
            align-items: center;
            font-size: 16px;
            height: 32px;
            padding: 0 10px;
            border-radius: 6px;
            transition: .2s ease-in-out;

            svg {
                margin-right: 8px;
                height: 16px;
                width: 16px;
                transform: rotate(-180deg);
            }

            &:hover {
                color: var(--dark-blue);
                background-color: var(--black-10);
            }
        }

        p {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }

        .edit-btn {
            color: var(--black-90);
            font: var(--font-fg-12);
            cursor: pointer;
            display: flex;
            align-items: center;
            height: 32px;
            padding: 0 10px;
            border-radius: 6px;
            transition: .2s ease-in-out;

            &:hover {
                background-color: var(--black-10);
            }

            svg {
                margin-right: 8px;
                height: 14px;
                width: 14px;
            }
        }

        .view-btn {
            margin-left: 12px;
            display: inline-flex;
            font: var(--font-fg-12);
            transition: .2s ease-in-out;

            &:hover {
                background-color: var(--black-10);
            }
        }


    }

    .app-header {
        margin: 16px 0;
        padding-bottom: 16px;
        border-bottom: 1px solid var(--border);

        h1 {
            font: var(--font-med-30);
            color: var(--black-90);
            font-weight: normal;
            margin-bottom: 12px;
            display: flex;
            align-items: center;

            span {
                font-size: 12px;
                margin-left: 16px;
                height: 24px;
                display: inline-flex;
                align-items: center;
                padding: 0 8px;
                border-radius: 6px;
                background-color: var(--black-10);
                font-weight: normal;
            }
        }

        ul {
            display: flex;
            align-items: center;
            list-style: none;
            padding: 0;
            margin: 0;

            li {
                display: flex;
                align-items: center;
                margin-right: 16px;
                font-size: 12px;

                time,
                span {
                    color: var(--black-60);
                    display: flex;
                    align-items: center;
                    font-size: 12px;

                    svg {
                        margin-right: 5px;
                        height: 12px;
                        width: 12px;
                    }
                }

                span {
                    padding-right: 8px;
                }

                time {
                    color: var(--black-90);
                }

                &:last-child {
                    flex: 1;
                    justify-content: flex-end;
                    margin: 0;

                    span {
                        color: var(--black-90);
                        cursor: pointer;
                        font: var(--font-med-12);
                        padding: 0;

                        &:hover {
                            text-decoration: underline;
                            color: var(--blue);
                        }
                    }
                }
            }
        }

        .accepting {
            color: var(--black-90);
            display: inline-flex;
            align-items: center;
            text-transform: capitalize;

            &::before {
                content: '';
                height: 8px;
                width: 8px;
                border-radius: 50%;
                margin-right: 5px;
            }

            &.status-80 {
                &::before {
                    background: var(--blue);
                }
            }

            &.status-50 {
                &::before {
                    background: var(--black-75);
                }
            }

            &.status-0 {
                &::before {
                    background: var(--black-20);
                }
            }

            &.status-100 {
                &::before {
                    background: var(--green);
                }
            }
        }

    }




    .drop-box {
        display: flex;
        margin: 16px 0;
        align-items: center;

        .ui-search-input {
            flex: 1;
            margin-left: 8px;
            margin-right: 8px;
            
            .input {
                max-width: unset;
            }
        }

        .ui-dropdown {
            margin-right: 8px;

            .ui-button {
                border-color: var(--black-10);
                background-color: var(--black-10);
            }
        }
        
        .email-btn {
            margin: 0 8px;
            position: relative;

            .size-32 {
                padding-left: 8px;
                padding-right: 8px;

                svg {
                    height: 18px;
                    width: 18px;
                    margin-right: 0;
                    top: auto;
                }
            }

            ul {
                position: absolute;
                top: 32px;
                right: 0;
                background-color: var(--bg-01);
                border-radius: 6px;
                box-shadow: var(--bot-4dp);
                padding: 8px;
                list-style: none;
                margin: 0;
                z-index: 99;
                width: 160px;
                z-index: 999;

                li {
                    cursor: pointer;
                    color: var(--black-90);
                    font: var(--font-med-12);
                    padding: 8px 10px;
                    border-radius: 4px;

                    &.disabled {
                        cursor: not-allowed;
                        opacity: .5;
                        pointer-events: none;
                    }

                    &:hover {
                        background-color: var(--bg-02);
                    }
                }
            }
        }

        .edit-btn {
            padding-left: 12px;
            padding-right: 6px;

            &.size-32 {
                svg {
                    height: 16px;
                    width: 16px;
                    margin-right: 0;
                    margin-left: 2px;
                }
            }
        }
    }
    
    .ui-table {
        position: relative;

        thead {
            position: sticky;
            top: 0;
        }

        td,
        th {
            white-space: nowrap;
            font-size: 12px;
        }

        tr {
            td,
            th {
                &.fir-child  {
                    max-width: 24px;
                }

                &:last-child {
                    max-width: 110px;
                }
            }
        }

        tr {
            th {
                background-color: var(--bg-02);

                &:last-child {

                    .ico {
                        justify-content: flex-end;
                    }
                }
            }

            &.checked td {
                background-color: var(--bg-02);
            }

            td {
                cursor: pointer;

                a {
                    color: var(--black-90);

                    &:hover {
                        color: var(--blue);
                        text-decoration: underline;
                    }
                }

                .automated {
                    display: flex;
                    align-items: center;
                    color: var(--black-50);
                    margin-top: 5px;

                    svg {
                        height: 10px;
                        width: 10px;
                        margin-left: 4px;
                        display: block;
                    }
                }
            }

            th:last-child,
            td:last-child {
                position: sticky;
                right: 0;

                &::before {
                    position: absolute;
                    width: 10px;
                    height: 100%;
                    left: -10px;
                    top: 0;
                    content: '';
                    background: linear-gradient(90deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, .1));
                }
            }

            td:last-child {
                background-color: white;
            }
        }

        .is-new {
            font: var(--font-med-10);
            color: var(--red);
        }

        .n-a {
            color: var(--neutral-60);
        }

        .social-icon {
            margin: 4px 6px 0 0;
            display: inline-flex;
            color: var(--black-90);

            svg {
                height: 10px;
                width: 10px;

                &.svg-icon--email {
                    height: 12px;
                    width: 12px;
                    position: relative;
                    top: 1px;
                }
            }

            &:hover {
                color: var(--blue);
            }
        }

        p {
            margin-top: 5px;
            font-size: 12px;
            color: var(--black-90);

            &:first-child {
                margin-top: 0;
            }

            .js-link,
            .link {
                cursor: pointer;
                color: var(--blue);

                &:hover {
                    text-decoration: underline;
                }
            }

            .blue {
                color: var(--blue);
            }

            .red {
                color: var(--red);
            }
        }

        .status-text {
            display: inline-flex;
            align-items: center;
            color: var(--black-90);



            &::before {
                content: '';
                height: 8px;
                width: 8px;
                border-radius: 50%;
                margin-right: 4px;
            }

            &.status-na {
                color: var(--neutral-60);

                &::before {
                    background: var(--black-40);
                }
            }

            &.status-active,
            &.status-send,
            &.status-success {
                &::before {
                    background: var(--green);
                }
            }

            &.status-ready,
            &.status-failed {
                &::before {
                    background: var(--red);
                }
            }
            
            &.status-invited,
            &.status-scheduled {
                &::before {
                    background: var(--yellow);
                }
            }
        }

        .status-btn {
            height: 32px;
            width: 92px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            border-radius: 6px;

            &.status-todo {
                color: var(--black-90);
                background-color: var(--black-20);
            }

            &.status-approved {
                color: var(--black-90);
                background-color: #A5E1BF;
            }

            &.status-rejected {
                color: var(--black-90);
                background-color: #FC9595;
            }

            &.status-reviewing {
                color: var(--black-90);
                background-color: #FFDE81;
            }

            &.status-waitlist {
                color: var(--black-90);
                background-color: #D3E1FE;
            }

            svg {
                margin-left: 2px;
                height: 16px;
                width: 16px;
            }
        }

        .disabeld-btn{
            opacity: .5;
        }

        .disabeld{
            .js-link{
                opacity: .5;
            }
        }
    }

    
}


.page-programs--application {
    .slide-up-down__container::after {
        content: '';
        display: block;
        height: 16px;
    }
    
    .msg {
        display: flex;
        align-items: center;
        background-color: var(--light-blue);
        padding: 12px 16px;
        color: var(--black-90);

        svg {
            margin-right: 16px;
            height: 18px;
            width: 18px;
        }

        p {
            font: var(--font-med-12);
            flex: 1;
        }

        span {
            color: var(--blue);
            cursor: pointer;
        }

        .close {
            cursor: pointer;
            margin-left: 16px;
            color: var(--black-50);

            &:hover {
                color: var(--black-90);
            }

            svg {
                height: 12px;
                width: 12px;
                margin: 0;
            }
        }
    }
}



.send-email-modal {
    .ui-modal--container {
        width: 620px;

        & > header {
            position: relative;
            height: 40px;
            display: flex;
            align-items: center;
            margin: 12px 0 0;

            h2 {
                font: var(--font-med-20);
                color: var(--black-90);
                display: flex;
                align-items: center;
                padding: 0 24px;

                span {
                    color: var(--black-60);
                    margin-left: 8px;
                }
            }
        }

        .col {
            padding: 0 24px 24px;

            .small-text {
                font-size: 12px;
                color: var(--black-75);
                margin-bottom: 8px;
            }

            .msg {
                display: block;
                font: var(--font-med-12);
                padding: 8px;
            }

            dl {
                margin: 16px 0;
                
                dt {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 8px;

                    h2 {
                        font: var(--font-med-14);
                        color: var(--black-90);
                        margin-top: 8px;
                    }

                    h3 {
                        font: var(--font-med-16);
                        color: var(--black-90);
                        display: flex;
                        align-items: center;

                        &::after {
                            content: '*';
                            color: var(--red);
                        }
                    }


                    span {
                        cursor: pointer;
                        font-size: 12px;
                        margin-left: 8px;
                        color: var(--black-75);

                        &:hover {
                            color: var(--blue);
                        }
                    }
                }

                .item {
                    display: inline-flex;
                    align-items: center;
                    padding: 8px;
                    background-color: var(--black-10);
                    border-radius: 4px;
                    margin: 0 8px 8px 0;

                    span {
                        font: var(--font-med-12);
                        color: var(--black-90);
                    }

                    i {
                        cursor: pointer;
                        margin-left: 6px;

                        svg {
                            height: 14px;
                            width: 14px;
                            fill: var(--red);
                        }
                    }
                }

                .alert {
                    background-color: var(--light-yellow);
                    font: var(--font-med-12);
                    color: var(--black-90);
                    padding: 8px 8px 8px 30px;
                    margin: 8px 0;
                    position: relative;

                    svg {
                        position: absolute;
                        left: 10px;
                        top: 9px;
                        height: 12px;
                        width: 12px;
                        fill: var(--black-75);
                    }

                    span {
                        color: var(--blue);
                        cursor: pointer;
                        text-decoration: underline;
                    }
                }
            }
        }

        .send-yourself {
            line-height: 1;
            
            label {
                display: inline-flex;
                align-items: center;
                font: var(--font-med-14);
                cursor: pointer;

                span {
                    color: var(--black-50);
                    padding-left: 6px;
                }
            }

            & > span {
                cursor: pointer;
                color: var(--blue);

                &:hover {
                    text-decoration: underline;
                }
            }
        }

        & > footer {
            padding: 0 24px 24px;
            display: flex;
            align-items: center;

            p {
                flex: 1;

                .edit-btn {
                    color: var(--black-90);
                    font: var(--font-fg-12);
                    cursor: pointer;
                    display: inline-flex;
                    align-items: center;
                    height: 32px;
                    padding: 0 10px;
                    border-radius: 6px;
                    transition: .2s ease-in-out;

                    &:hover {
                        background-color: var(--black-10);
                    }

                    svg {
                        height: 14px;
                        width: 14px;
                    }
                }
            }

            .ui-button {
                margin-left: 12px;
            }
        }
    }
}

.active-menu {
    position: fixed;
    left: 30%;
    top: 20%;
    z-index: 99;
    padding: 2px;
    background-color: var(--bg-01);
    width: 140px;
    border-radius: 6px;
    box-shadow: var(--bot-4dp);
    display: none;

    li {
        cursor: pointer;
        display: flex;
        align-items: center;
        color: var(--black-60);
        padding: 8px 10px;
        border-radius: 4px;

        &.disabled {
            cursor: not-allowed;
            opacity: .5;
            pointer-events: none;
        }

        &:hover {
            background-color: var(--bg-02);
        }

        span {
            flex: 1;
            color: var(--black-90);
            font: var(--font-med-12);
        }

        svg {
            height: 12px;
            width: 12px;
        }
    }

    .red-menu span{
        color:var(--red);
    }
}

.app-notifications {
    &.bottom-right {
        width: auto !important;
    }
}

.long-notifications {
    &.bottom-right {
        width: 560px !important;
    }
}

.edit-settings-modal {

    .ui-navi {
        flex: none;
    }

    .loading.static {
        top: 200px;
        position: relative;
        height: auto;
    }

    & > .ui-modal--container {
        height: auto;
        width: 680px;
        min-height: 580px;
    }

    .data-list-right {
        height: 600px;
        width: 680px;
        position: relative;
        padding: 0px;
        border-radius: 16px;
    }


    .set-box {
        padding: 0 24px 24px;
        margin: 0;

        .question-templeat .save-btn {
            display: none;
        }

        .edit-item {
            margin:  16px 0;
        }
    }
}

.exceeded-modal {
    .ui-modal--container {
        width: 460px;
        
        .box {
            text-align: center;

            .close {
                position: absolute;
                top: 16px;
                right: 16px;
                cursor: pointer;
                height: 14px;
                width: 14px;

                svg {
                    height: 100%;
                    width: 100%;
                    fill: var(--black-50);
                }

                &:hover {
                    svg {
                        fill: var(--black-90);
                    }
                }
            }

            & > i {
                height: 42px;
                width: 42px;
                display: block;
                margin: 24px auto 32px;

                svg {
                    height: 42px;
                    width: 42px;
                    display: block;
                    color: #FC9595;
                    fill: var(--black-90);
                }
            }


            & > h2 {
                font: var(--font-med-24);
                color: var(--black-90);
                text-align: center;
                margin: 0 0 16px;
            }


            .btns {
                justify-content: center !important;

                .ui-button {
                    padding-left: 32px;
                    padding-right: 32px;
                    margin: 0 !important;
                }
            }

            p{
                display: block;
                span{
                    font-weight: bold;
                }
            }
        }

    }
}


.not-allowed-btn{
    cursor: not-allowed;
    opacity: .7;
    pointer-events: none;
}

.updating-dialog{
    header{
        display: none;
    }
    h3{
        font: var(--font-demi-20);
        color: var(--black-90);
        margin: 8px 0;
    }

    p{
        font-size: 16px;
        .strong{
            font-weight: 800;
        }
    }

    .btn-footer{
        display: flex;
        justify-content: flex-end;
    }

    .dialog--10{
        background-color: var(--red);
        border: none;
    }
}
</style>